<template>
  <div>
    <!-- Editor principale -->
    <v-dialog persistent v-model="display" width="900">
      <v-card v-if="display == true">
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Modifica Dispositivo</v-toolbar-title>
          <v-spacer />
          <v-btn small light @click="salvaDettaglioDispositivo">
            <v-icon color="success">mdi-floppy</v-icon>
          </v-btn>
          <v-spacer />
          <v-btn small light @click="stampaEtichettaBox">
            <v-icon color="primary">mdi-printer</v-icon>
          </v-btn>
          <v-spacer />
          <v-btn small light @click="display = false">
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container :key="ui_key">
          <v-row justify="center">
            <v-col cols="3" md="3" sm="3" lg="3" align="center">
              <v-text-field
                v-model="template.device_name"
                label="Nome Dispositivo"
              />
            </v-col>
            <v-col cols="3" md="3" sm="3" lg="3" align="center">
              <v-text-field v-model="template.serial" label="Seriale" />
            </v-col>
            <v-col cols="3" md="3" sm="3" lg="3" align="center">
              <v-select
                v-model="template.id_azienda"
                :items="clienti"
                item-text="ragione_sociale"
                item-value="id_azienda"
                label="Cliente"
              />
            </v-col>
            <v-col cols="3" md="3" sm="3" lg="3" align="center">
              <v-select
                v-model="template.tipo_piattaforma"
                :items="piattaforme"
                item-text="nome"
                item-value="id_piattaforma"
                label="Piattaforma"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="4" md="4" sm="4" lg="4" align="center">
              <v-text-field v-model="template.tipo_box" label="Tipo Box" />
            </v-col>
            <v-col cols="4" md="4" sm="4" lg="4" align="center">
              <v-text-field
                v-model="template.versione_core"
                label="Versione Core"
              />
            </v-col>
            <v-col cols="4" md="4" sm="4" lg="4" align="center">
              <v-text-field
                v-model="template.ultimo_aggiornamento"
                label="Ultimo Aggiornamento"
                type="datetime-local"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="6" align="center">
              <v-text-field
                label="Indirizzo MAC 1"
                v-model="template.mac1"
                @change="ui_key++"
              />
            </v-col>
            <v-col cols="6" align="center">
              <v-text-field
                label="Indirizzo MAC 2"
                v-model="template.mac2"
                @change="ui_key++"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="3">
              <v-checkbox
                label="Usa DHCP"
                class="ma-0 pa-0"
                v-model="template.settings.network.dhcp"
                @change="ui_key++"
              />
            </v-col>
            <v-col cols="3">
              <v-checkbox
                label="Ha Canale SSH"
                class="ma-0 pa-0"
                :true-value="1"
                :false-value="0"
                v-model="template.flag_ssh"
                @change="ui_key++"
              />
            </v-col>
          </v-row>
          <div v-if="template.settings.network.dhcp != true">
            <v-row class="my-0" align="center">
              <v-col cols="4">
                <v-text-field
                  label="IP"
                  v-model="template.settings.network.ip"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  label="Subnet mask"
                  type="number"
                  :min="0"
                  :max="32"
                  v-model="template.settings.network.subnet"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Gateway"
                  v-model="template.settings.network.gateway"
                />
              </v-col>
            </v-row>
            <v-row class="my-0" align="center" justify="center">
              <v-col cols="2">
                <v-btn
                  color="primary"
                  @click="
                    $refs.dialog_ip.open(template.settings.network.add_ip)
                  "
                  >ip aggiuntivi</v-btn
                >
              </v-col>
              <v-col cols="2">
                <v-btn
                  color="primary"
                  @click="$refs.dialog_dns.open(template.settings.network.dns)"
                  >dns</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-container>
        <v-card-actions>
          <v-container>
            <v-row justify="center">
              <v-col cols="4">
                <v-btn
                  text
                  color="error"
                  @click="delete_prompt = true"
                  class="mb-n4"
                  >Elimina Dispositivo</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog IP statici secondari -->
    <DialogIpQuickConnext ref="dialog_ip" />

    <!-- Dialog DNS -->
    <DialogDnsQuickConnext ref="dialog_dns" />

    <!-- Conferma eliminazione -->
    <v-dialog persistent width="400" v-model="delete_prompt">
      <v-card>
        <v-container>
          <v-card-title>Eliminare il dispositivo?</v-card-title>
        </v-container>
        <v-card-actions>
          <v-btn text color="primary" @click="delete_prompt = false"
            >Annulla</v-btn
          >
          <v-spacer />
          <v-btn text color="error" @click="eliminaDispositivo">Elimina</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import DialogDnsQuickConnext from "./Dialog Rete/DialogDnsQuickConnext.vue";
import DialogIpQuickConnext from "./Dialog Rete/DialogIpQuickConnext.vue";
import ipformat from "./Dialog Rete/ipformat";
export default {
  name: "DialogAnagraficaQuickConnext",
  components: {
    DialogDnsQuickConnext,
    DialogIpQuickConnext,
  },
  props: {
    clienti: Array,
    dispositivi: Array,
    piattaforme: Array,
  },
  data() {
    return {
      delete_prompt: false,
      display: false,
      NETWORK: null,
      src: null,
      template: new Object(),
      ui_key: 0,
    };
  },
  mounted() {
    this.NETWORK = this.$store.state.Network;
  },
  methods: {
    stampaEtichettaBox() {
      let request = {
        controller: "Report",
        method: "POST",
        richiesta: {
          action: "getreportpdf",
          token: localStorage.getItem("user_token"),
          cod_report: "ETICHETTA_BOX",
          parametri: [
            {
              parametro: "@device_id",
              valore: this.src.device_id,
            },
          ],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (
            "tipo_messaggio" in res.data &&
            "query_messaggio" in res.data &&
            res.data.tipo_messaggio == 1
          ) {
            this.$refs.SnackbarQV.print("orange", res.data.query_messaggio);
          }
          const byteCharacters = atob(res.data.result);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {
            type: "application/pdf",
          });
          const blobUrl = URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = blobUrl;
          a.download = "etichetta.pdf";
          document.body.appendChild(a);
          a.click();
        })
        .catch((err) => {
          if (
            "tipo_messaggio" in err.response.data &&
            "query_messaggio" in err.response.data &&
            err.response.data.tipo_messaggio == 2
          ) {
            this.$refs.SnackbarQV.print(
              "error",
              err.response.data.query_messaggio
            );
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        });
    },
    apri(item = null) {
      const template = this.template;
      const dialog_keys = Object.keys(template);
      for (let i = 0; i < dialog_keys.length; i++) {
        delete template[dialog_keys[i]];
      }
      if (item == null) {
        this.src = null;
        Object.assign(template, {
          device_id: -1,
          device_name: null,
          id_azienda: null,
          settings: null,
          serial: null,
          tipo_piattaforma: null,
          enabled: 1,
        });
      } else {
        this.src = item;
        Object.assign(template, item);
      }
      try {
        template.settings = JSON.parse(
          decodeURIComponent(escape(atob(template.settings)))
        );
        if (!template.settings.network) {
          template.settings.network = {
            dhcp: true,
            ip: null,
            subnet: 24,
            gateway: null,
            dns: ["8.8.8.8", "8.4.4.4"],
            add_ip: new Array(),
          };
        }
      } catch {
        template.settings = {
          network: {
            dhcp: true,
            ip: null,
            subnet: 24,
            gateway: null,
            dns: ["8.8.8.8", "8.4.4.4"],
            add_ip: new Array(),
          },
        };
      }
      this.display = true;
    },
    eliminaDispositivo() {
      const device = this.src;
      const that = this;

      function closeAll() {
        that.display = false;
        that.delete_prompt = false;
      }

      if (device == null) {
        closeAll();
      } else if (device.device_id == -1) {
        this.dispositivi.splice(this.dispositivi.indexOf(device), 1);
        closeAll();
      } else {
        const request = {
          controller: "quickconnext",
          endpoint: "connext",
          body: {
            action: "setdeviceinfo",
            token: localStorage.user_token,
            devices: [
              {
                device_id: device.device_id,
                validita: 0,
              },
            ],
          },
          response: { parse: false },
          method: "PUT",
          on: {
            load: function () {
              closeAll();
              that.dispositivi.splice(that.dispositivi.indexOf(device), 1);
            },
          },
        };
        this.NETWORK.AjaxRequest(request);
      }
    },
    salvaDettaglioDispositivo() {
      if (!this.template.settings.network.dhcp) {
        if (!ipformat.checkIpFormat(this.template.settings.network.ip)) {
          alert("L'indirizzo IP impostato ha un formato non corretto");
          return;
        }
        const subnet = Number(this.template.settings.network.subnet);
        if (isNaN(subnet) || subnet <= 0 || subnet >= 32) {
          alert(
            "La maschera di sottorete impostata ha un formato non corretto"
          );
          return;
        }
        if (!ipformat.checkIpFormat(this.template.settings.network.gateway)) {
          alert("Il gateway impostato ha un formato non corretto");
          return;
        }
      }
      this.display = false;
      let device = this.src;
      if (device == null) {
        device = new Object();
        this.dispositivi.push(device);
      }
      this.template.settings = btoa(
        unescape(encodeURIComponent(JSON.stringify(this.template.settings)))
      );
      Object.assign(device, this.template);
    },
  },
};
</script>
